import { interactionsEnTranslations } from './interactions.en';
import { interactionsHeTranslations } from './interactions.he';

export const interactionsTranslations = {
  en: interactionsEnTranslations,
  he: interactionsHeTranslations,
} as const;
